import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const ExpireContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  width: 100%;
  min-width: 0;
`;

export const ExpireValueInput = styled.div`
  flex-shrink: 0;
  width: 80px;
`;

export const ExpireUnitSelect = styled.div`
  flex: 1;
  min-width: 0;
`;

export const NeverExpiresWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  white-space: nowrap;
`;

